import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#03070F]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-14 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src="/assets/logo/neurobolt_icon_clean.svg"
              alt=""
              className="h-9 w-9"
            />
            <div>
              <div className="font-display text-white text-[18px] font-semibold tracking-tight">
                Neurobolt<span className="text-[#38BDF8]">.AI</span>
              </div>
              <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#64748B] mt-1">
                Rewire · Refine · Redefine
              </div>
            </div>
          </div>
          <p className="mt-5 text-[#94A3B8] text-[14px] max-w-md leading-relaxed">
            A research-stage platform for AI-powered neuroplasticity through
            biocompatible brain-interface technology.
          </p>
          <a
            href="mailto:contact@neurobolt.ai"
            className="mt-5 inline-flex items-center gap-2 text-[13px] text-[#CBD5E1] link-underline"
          >
            <Mail size={14} className="text-[#38BDF8]" />
            contact@neurobolt.ai
          </a>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
          <div>
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#475569]">
              Platform
            </div>
            <ul className="mt-4 space-y-3 text-[14px] text-[#CBD5E1]">
              <li><Link to="/platform" className="hover:text-white">Closed loop</Link></li>
              <li><Link to="/technology" className="hover:text-white">Technology</Link></li>
              <li><Link to="/ai" className="hover:text-white">AI modeling</Link></li>
              <li><Link to="/applications" className="hover:text-white">Applications</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#475569]">
              Company
            </div>
            <ul className="mt-4 space-y-3 text-[14px] text-[#CBD5E1]">
              <li><Link to="/team" className="hover:text-white">Team</Link></li>
              <li><Link to="/research" className="hover:text-white">Research</Link></li>
              <li><Link to="/partner" className="hover:text-white">Partner</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#475569]">
              Disclosure
            </div>
            <p className="mt-4 text-[12.5px] text-[#64748B] leading-relaxed">
              Neurobolt.AI is research-stage. We do not claim to cure, treat,
              diagnose, reverse, or clinically validate outcomes.
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="font-mono text-[11px] tracking-widest uppercase text-[#475569]">
            © 2026 Neurobolt.AI · All rights reserved
          </div>
          <div className="font-mono text-[11px] tracking-widest uppercase text-[#475569]">
            Built for the future of brain health
          </div>
        </div>
      </div>
    </footer>
  );
}
